import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface BlockHeightData {
  currentBlock: number;
  nextHalvingBlock: number;
  blocksRemaining: number;
  secondsUntilHalving: number;
  estimatedDate: string;
  avgBlockTime: number;
}

export const useBlockHeight = () => {
  return useQuery({
    queryKey: ["blockHeight"],
    queryFn: async () => {
      console.log("Fetching Bitcoin block height data...");
      const { data, error } = await supabase.functions.invoke("fetch-block-height");

      if (error) {
        console.error("Error fetching block height:", error);
        throw error;
      }

      console.log("Block height data received:", data);
      return data as BlockHeightData;
    },
    refetchInterval: 10 * 60 * 1000, // Refetch every 10 minutes
    staleTime: 5 * 60 * 1000, // Data is fresh for 5 minutes
  });
};
